<div class="invitation-item ct-card">
  <div class="details">
    <b class="title">{{ invitation().jobTitle }}</b>
    <span class="company text-muted">{{ invitation().companyName }}</span>
    <span class="date text-muted">
      {{
        'jobboard.platform.dashboard.invitations.received-at'
          | transloco: { date: (invitation().receivedAt | date: 'dd.MM.yyyy') }
      }}
    </span>
  </div>
  <div class="actions">
    @if (invitation().closed) {
      <span class="text-muted">
        {{ 'jobboard.platform.jobs.invitations.closed-tag' | transloco }}
      </span>
    } @else {
      <app-button
        variant="primary"
        [small]="true"
        [iconStart]="icons.check"
        (click)="accept()"
      >
        {{ 'jobboard.platform.jobs.saved.apply-cta' | transloco }}
      </app-button>
      <app-button
        variant="white-grey"
        [small]="true"
        [iconStart]="icons.times"
        (click)="decline()"
      >
        {{ 'jobboard.platform.dashboard.invitations.decline' | transloco }}
      </app-button>
    }
  </div>
</div>
